module.exports = __webpack_public_path__ + "img/tcApi_step3.6186f3dd.png";